<template>
  <el-dialog
    v-model="isVisible"
    :title="header"
    width="90%"
    @opened="setCurrent"
    @close="close"
  >
    <el-form ref="formObj" v-loading="withLoader" :model="form" :rules="rules">
      <el-form-item
        v-show="rules.title"
        label="Title"
        prop="title"
        :error="errors.title"
      >
        <el-input v-model="form.title" autocomplete="off" />
      </el-form-item>
      <el-form-item :label="ipsLabel" prop="ip_string" :error="validationError">
        <IpListEditor v-model="form.ip_string" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="close">Cancel</el-button>
        <el-button type="primary" @click="save">{{ saveBtnText }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script lang="ts">
import { defineComponent, ref, watch, computed, onMounted } from 'vue'
import { IIPListFilter } from '@/api/ip_lists'
import useResize from '@/hooks/useResize'
import IpListEditor from '@/components/IpListEditor.vue'
import { CampaignValidationErrorsKey } from '@/api/types'
import useValidation from '@/hooks/useValidation'
import { useIPListsStore } from '@/apps/traforama/store/ipLists'
const SAVE_MODE = 'save'
const ADD_MODE = 'add'
const REMOVE_MODE = 'remove'
const CLONE_MODE = 'clone'

export default defineComponent({
  name: 'Modal',
  components: { IpListEditor },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      required: true
    }
  },
  setup(props, context) {
    const ipListsStore = useIPListsStore()
    const isVisible = ref(props.visible)
    const withLoader = ref(props.loading)
    const mode = ref(props.mode)

    const formObj = ref(null)
    const rule = {
      required: true,
      message: 'This field is required',
      trigger: 'change'
    }

    const rules = computed(() => {
      const reulstRules: Record<string, any> = { ip_string: rule }
      if (selected.value.length < 1 || mode.value === SAVE_MODE) {
        reulstRules['title'] = rule
      } else {
        delete reulstRules['title']
      }
      return reulstRules
    })

    const form = ref({ title: '', ip_string: '' } as Record<string, any>)

    const selected = computed(() => {
      return ipListsStore.selected
        ? Object.values(ipListsStore.selected).map(
            ({ attributes }) => attributes
          )
        : []
    })

    const header = computed(() => {
      return selected.value.length && mode.value !== SAVE_MODE
        ? 'Choosen lists:' +
            selected.value
              .map(({ id, title }) => {
                return `${id} ${title}`
              })
              .join(', ')
        : 'IPs list'
    })

    const ipsLabel = computed(() => {
      let label = 'IPs'
      if (selected.value.length) {
        label = `${label} to ${mode.value === REMOVE_MODE ? 'Remove' : 'Add'}`
      }
      return label
    })

    const save = () => {
      // @ts-ignore: Object is possibly 'null'.
      formObj.value.validate(async (valid: boolean) => {
        if (valid) {
          context.emit('save', form.value)
        }
      })
    }

    const { validationErrors } = useValidation(CampaignValidationErrorsKey)
    const errors = validationErrors()

    const validationError = computed(() => {
      return errors.value?.ip_string || errors.value?.ip_nets
    })

    const close = () => {
      // @ts-ignore: Object is possibly 'null'.
      formObj.value.resetFields()
      context.emit('close')
    }

    const saveBtnText = computed(() => {
      return selected.value.length
        ? `${mode.value === REMOVE_MODE ? 'Remove' : 'Add'}`
        : 'Save'
    })
    const setCurrent = () => {
      if (ipListsStore.current) {
        form.value = { ...ipListsStore.current }
      } else {
        form.value = { title: '', ip_string: '' }
      }
      // @ts-ignore: Object is possibly 'null'.
      formObj.value.resetFields()
    }

    watch(
      (_: any) => props.visible,
      (val: any) => {
        isVisible.value = val
      }
    )
    watch(
      (_: any) => props.loading,
      (val: any) => {
        withLoader.value = val
      }
    )
    watch(
      (_: any) => props.mode,
      (val: any) => {
        mode.value = val
      }
    )

    return {
      isVisible,
      form,
      setCurrent,
      header,
      rules,
      save,
      close,
      formObj,
      errors,
      validationError,
      withLoader,
      saveBtnText,
      ipsLabel
    }
  }
})
</script>
